<template>
  <div>
    <div v-if="nodeData" class="organism-node-info_container">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <span class="equipment__name">{{ nodeData.hostname }}</span>
          <b-badge
            pill
            class="ml-2"
            :variant="badgeStatusVariant(nodeData.nodeStatus)"
          >
            {{ nodeData.nodeStatus }}
          </b-badge>
        </div>
        <div class="d-none d-md-flex backup-status__wrapper">
          <span
            v-if="nodeData.backupStatus.toLowerCase() === 'success'"
            class="backup-status text-success"
            ><b>Backup Successful</b>
          </span>
          <span
            v-else-if="nodeData.backupStatus.toLowerCase() === 'waiting'"
            class="backup-status text-warning"
            ><b>Waiting</b>
          </span>
          <span v-else class="backup-status text-danger"
            ><b>Backup Failed</b>
          </span>
        </div>
      </div>
      <div class="d-flex d-md-none backup-status__wrapper">
        <span>Backup Status:&nbsp;</span>
        <span
          v-if="nodeData.backupStatus.toLowerCase() === 'success'"
          class="backup-status text-success"
          ><b> Backup Successful</b>
        </span>
        <span
          v-else-if="nodeData.backupStatus.toLowerCase() === 'waiting'"
          class="backup-status text-warning"
          ><b> Waiting</b>
        </span>
        <span v-else class="backup-status text-danger"
          ><b> Backup Failed</b>
        </span>
      </div>
      <div>
        <molecule-edit-node-tag
          :tagList="nodeData.tags"
          :tagOptions="tagOptions"
          :isEditable="canUpdate"
          @onUpdateCurrentNodeTagList="onUpdateCurrentNodeTagList"
        ></molecule-edit-node-tag>
      </div>
      <div class="mt-1">
        <span><b>IP Address:</b> {{ nodeData.ipAddress }}</span>
      </div>
      <div class="row w-100 equipment__description">
        <div class="col-12 custom-pre-line">{{ nodeData.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import MoleculeEditNodeTag from "@/components/molecules/networkConfigurationManagement/MoleculeEditNodeTag.vue"

export default {
  name: "MoleculeNodeInformation",
  components: {
    BBadge,
    MoleculeEditNodeTag,
  },
  props: {
    nodeData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    tagOptions: {
      type: Array,
      required: true,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    badgeStatusVariant(nodeStatus) {
      if (nodeStatus?.toLowerCase() === "up") return "light-success"
      else if (nodeStatus?.toLowerCase() === "down") return "light-danger"
      else if (nodeStatus?.toLowerCase() === "decommission") return "light-dark"
    },
    onUpdateCurrentNodeTagList(tagList) {
      this.$emit("onUpdateCurrentNodeTagList", tagList)
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-node-info_container {
  padding: 15px 15px 15px 15px;
}

.equipment__name {
  font-weight: 700;
  font-size: 30px;
  color: #7367f0;
}

.equipment__description {
  margin-top: 20px;
}

.custom-pre-line {
  white-space: pre-line;
}

.backup-status__wrapper {
  margin-top: 8px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .organism-node-info_container {
    padding: 31px 38px 21px 38px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .backup-status__wrapper {
    margin-top: 0px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
